import { CircularButtonProps } from "@/components/CircularButton";
import CircularRectTextButton from "@/components/CircularButton/styled/CircularRectTextButton";
import { borderRadius } from "@/utils/borderRadius";

export const ChatEditorToolbarBtn = ({
    id,
    icon,
    onClick,
    children,
    style,
    ...btnProps
}: { icon?: React.ReactNode } & CircularButtonProps) => {
    return (
        <CircularRectTextButton
            id={id}
            style={{ width: "3rem", height: "3rem", borderRadius: borderRadius.circular, ...style }}
            onClick={onClick}
            {...btnProps}>
            {children || icon}
        </CircularRectTextButton>
    );
};
